export default "__VITE_ASSET__B8SBYwM5__"